import {
  ActionEmptyState,
  Button,
  Card,
  CardContent,
  DataTable,
  Typography,
} from "@/components/ui";
import { getDashboardPinnedMattersColumns } from "@/components/ui/DashboardPinnedMattersCard/dashboard-pinned-matters-columns";
import { PinnedMatterRowContextMenu } from "@/components/ui/DashboardPinnedMattersCard/PinnedMatterRowContextMenu";
import { retrievePinnedMattersQueryOptions } from "@/lib/data/react-query/matters/matter-pinned";
import { tanstackTableNames } from "@/lib/data/static/tanstack-table-names";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { Pin } from "lucide-react";
import { useMemo } from "react";

export const DashboardPinnedMattersCard = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery(
    retrievePinnedMattersQueryOptions(),
  );
  const columns = useMemo(() => getDashboardPinnedMattersColumns(), []);

  const pinnedMatters = data?.data ?? [];

  return (
    <Card>
      <CardContent className="w-full pt-4">
        <div className="mb-4 ml-2">
          <Typography variant="heading" color="primary">
            Pinned matters
          </Typography>
        </div>
        <DataTable
          entityLabelPlural="matters"
          allowLocalStorage={false}
          hideSearchBar
          hideVisiibilityDropdown
          columns={columns}
          data={pinnedMatters}
          onRowClick={async (row) => {
            const matterId = row.original.matter.id;
            if (!matterId) return;

            await navigate({
              to: "/matters/$matterId",
              params: { matterId },
            });
          }}
          renderRowContextMenu={(row, trigger) => (
            <PinnedMatterRowContextMenu
              pinnedMatter={row.original}
              trigger={trigger}
            />
          )}
          tableName={tanstackTableNames.dashboardPinnedMatters}
          isLoading={isLoading}
          isError={Boolean(error)}
          noResultsMessage="No pinned matters found."
          noResultsContent={
            <ActionEmptyState
              icon={<Pin className="h-5 w-5" />}
              title="No pinned matters yet"
              description="Pin a matter to keep it one click away on the dashboard."
              actions={
                <Button asChild size="sm">
                  <Link to="/matters">View matters</Link>
                </Button>
              }
            />
          }
        />
      </CardContent>
    </Card>
  );
};
